import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ec06928&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6ec06928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec06928",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ec06928')) {
      api.createRecord('6ec06928', component.options)
    } else {
      api.reload('6ec06928', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6ec06928&scoped=true&", function () {
      api.rerender('6ec06928', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hc/components/customerDialog/index.vue"
export default component.exports